import 'pro';

import Vue from 'vue';

import Directives from './directives';
import Components from './components';

import '@/css/index.less';
import App from '@/app';

import Loader from '@/loader';
Vue.use(Loader, {
  async load({ router }) {

    router.beforeEach((to, from, next) => {
      if (to.matched.length) {
        next();
      } else {
        router.back();
      }
    });

    router.beforeResolve((to, from, next) => {
      next();
    });

    Vue.use(Directives);
    Vue.use(Components);

    new Vue(Object.assign(App, { router })).$mount('#app');

  }
});




